<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M53 21h-6.8A9 9 0 0033.14 8.64 9.36 9.36 0 0032 10a9.36 9.36 0 00-1.14-1.39A9 9 0 0017.81 21H11a2 2 0 00-2 2v30a2 2 0 002 2h42a2 2 0 002-2V23a2 2 0 00-2-2zm-1 15H33.5V24H52zM35.26 10.76a6 6 0 018.49 8.48A6 6 0 0139.5 21h-6v-2.94-3.09a6 6 0 011.76-4.21zm-15 8.48A6 6 0 1130.5 15v6h-6a5.93 5.93 0 01-4.24-1.76zM24.5 24h6v12H12V24zM12 39h18.5v13H12zm21.5 13V39H52v13z"/></svg>